import { TruckSize, UliActivityType, UliOrigin } from '../../../../../common';
import { AllocationViewNextActionModel } from './allocation-view-next-action.model';
import { Region } from '../../transport/constants/transport-list.constant';
import { AllocationViewRuleModel } from './allocation-view-rule.model';
import { AllocationViewUliErpInformationModel, AllocationViewUliParty } from './allocation-view-list.model';
import { LocalDateRangeModel } from '../../../../models';
import { TruckLoadingType } from '../../../administration';
import { AllocationViewTruckActionModel } from './allocation-view-truck-action-model';

export class AllocationViewSlotBriefTruckInfoModel {
  carrierExtId: string;
  carrierName: string;
  carrierNumber: string;
  freeTextCarrierName: string;
  status: string;
  trailerPlateId: string;
  trailerPlateIdCountryOfOrigin: string;
  truckId: number;
  truckPlateId: string;
  truckPlateIdCountryOfOrigin: string;
  truckSize: TruckSize;
  truckLoadingTypes: TruckLoadingType[];
}

export class AllocationViewSlotBriefUliInfoModel {
  load: string;
  loadRegion: Region;
  origin: UliOrigin;
  status: string;
  type: UliActivityType;
  uli: string;
  erpInformation: AllocationViewUliErpInformationModel;
  compartmentId: number;
  leadUli: boolean;
  parties: AllocationViewUliParty[];
  numberOfHu: number;
}

export class AllocationViewSlotBriefModel {
  actions: AllocationViewNextActionModel[];
  compartmentId: number;
  compartmentName: string;
  dockId: number;
  dockName: string;
  hubId: number;
  hubName: string;
  slotId: number;
  placeholder: boolean;
  restricted: boolean;
  truckInfo: AllocationViewSlotBriefTruckInfoModel;
  uliInfos: AllocationViewSlotBriefUliInfoModel[];
  ruleInfo: AllocationViewRuleModel;
  timeFrame: LocalDateRangeModel;
  truckActions: AllocationViewTruckActionModel[];
}
